import styled from "@emotion/styled";
import { Button, Input, Space, DatePicker } from "antd";
import dayjs from "dayjs";
import { FC, SetStateAction, useEffect, useState } from "react";

interface SearchTaxFormProps {
    searchInput: string;
    setSearchInput: (value: SetStateAction<string>) => void;
    dateStartInput: string;
    setDateStartInput: (value: SetStateAction<string>) => void;
    dateEndInput: string;
    setDateEndInput: (value: SetStateAction<string>) => void;
}

const SearchTaxForm: FC<SearchTaxFormProps> = ({
    searchInput,
    setSearchInput,
    dateStartInput,
    setDateStartInput,
    dateEndInput,
    setDateEndInput,
}) => {
    const [tempSearchInput, setTempSearchInput] = useState<string>(searchInput);
    const [tempDateStartInput, setTempDateStartInput] = useState<string>(dateStartInput);
    const [tempDateEndInput, setTempDateEndInput] = useState<string>(dateEndInput);

    useEffect(() => {
        setTempSearchInput(searchInput);
    }, [searchInput]);

    useEffect(() => {
        setTempDateStartInput(dateStartInput);
    }, [dateStartInput]);

    useEffect(() => {
        setTempDateEndInput(dateEndInput);
    }, [dateEndInput]);

    const handleSearch = () => {
        setSearchInput(tempSearchInput);
        setDateStartInput(tempDateStartInput);
        setDateEndInput(tempDateEndInput);
    };

    const handleClear = () => {
        setTempSearchInput('');
        setTempDateStartInput('');
        setTempDateEndInput('');
        setSearchInput('');
        setDateStartInput('');
        setDateEndInput('');
    };

    const handleDateStartChange = (date: any) => {
        setTempDateStartInput(date ? dayjs(date).format('YYYY-MM-DD') : '');
    };

    const handleDateEndChange = (date: any) => {
        setTempDateEndInput(date ? dayjs(date).format('YYYY-MM-DD') : '');
    };

    return (
        <ButtonWrapper>
            <Space.Compact>
                <Input
                    style={{ height: '32px' }}
                    placeholder="ค้นหาคำสั่งซื้อ"
                    value={tempSearchInput}
                    onChange={(e) => setTempSearchInput(e.target.value)}
                />
                <DatePicker
                    style={{ width: '100%' }}
                    placeholder="วันที่เริ่มต้น"
                    format={"DD/MM/YYYY"}
                    placement="topRight"
                    showToday={true}
                    inputReadOnly={true}
                    value={tempDateStartInput ? dayjs(tempDateStartInput) : null}
                    onChange={handleDateStartChange}
                />
                <DatePicker
                    style={{ width: '100%' }}
                    placeholder="วันที่สิ้นสุด"
                    format={"DD/MM/YYYY"}
                    placement="topRight"
                    showToday={true}
                    inputReadOnly={true}
                    value={tempDateEndInput ? dayjs(tempDateEndInput) : null}
                    onChange={handleDateEndChange}
                />
                <Button type="default" style={{float:"right"}} onClick={handleSearch}>ค้นหา</Button>
                {(tempSearchInput || tempDateStartInput || tempDateEndInput) && (
                    <Button type="default" onClick={handleClear}>X</Button>
                )}
            </Space.Compact>
        </ButtonWrapper>
    );
};

export default SearchTaxForm;

const ButtonWrapper = styled.div`
    display: flex;
    flex-direction: row;
    width: 100%;
    height: 100%;
`;
